import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import * as CouponService from '../../api/couponService';
import * as StampCardService from '../../api/stampCardService';
import * as LoyaltyRewardService from '../../api/loyaltyRewardsService';
// import * as MerchantService from '../../api/merchantService';

import useNavContext from '../../hooks/useNavContext';

import Spinner from '../../components/Spinner';
import ErrorDialog from '../../components/Dialogs/ErrorDialog';
import AddStampDialog from '../../components/Dialogs/AddStampDialog';
import AddStampSuccessDialog from '../../components/Dialogs/AddStampSuccessDialog';
import useStampCardContext from '../../hooks/useStampCardContext';
import useMerchantContext from '../../hooks/useMerchantContext';

interface RouteParams {
  couponCode: string;
  merchantId: string;
  status: string;
  msg: string;
}

/**
 * Merchant
 */
export default function RedeemCouponScreen() {
  const { couponCode, merchantId, status, msg } = useParams<RouteParams>();
  const [isLoading, setIsLoading] = useState(true);
  const [launchAlertDialog, setLaunchAlertDialog] = useState(false);
  const [launchAddStampDialog, setLaunchAddStampDialog] = useState(false);
  const [stampSuccessDialog, setStampSuccessDialog] = useState(false);
  const [stampCard, setStampCard] = useState<StampCardService.StampCard | null>(
    null,
  );
  const [addedStamp, setAddedStamp] = useState(0);
  const [milestoneThresholdList, setMilestoneThresholdList] = useState<
    number[]
  >([]);
  const code = couponCode;
  const [mId, setMId] = useState(merchantId);
  const nav = useNavContext();
  const selectedMerchant = useMerchantContext();

  const history = useHistory();
  const sc = useStampCardContext();

  // const handleSuccessfulRedeem = useCallback(async () => {
  //   try {
  //     const resCoupon = await CouponService.get(couponCode);

  //     if (resCoupon && resCoupon.stampCard.id) {
  //       const resStampCard = await StampCardService.get(resCoupon.stampCard.id);

  //       const resMilestone = await LoyaltyRewardService.listMilestone(
  //         resStampCard.loyalty_campaign.id,
  //       );

  //       if (resMilestone && resMilestone.length > 0) {
  //         setMilestoneThresholdList(resMilestone.map((m) => m.threshold));
  //       }

  //       setStampCard(resStampCard);
  //       setAddedStamp(1);
  //       setTimeout(() => {
  //         setIsLoading(false);
  //         setStampSuccessDialog(true);
  //       }, 500);
  //     }
  //   } catch (e) {
  //     console.log('Error fetching coupon after redeem: ', e);
  //   }
  // }, [couponCode]);

  // useEffect(() => {
  //   let init = false;
  //   if (status === 'success') {
  //     if (!init && isLoading && couponCode) {
  //       // handle successful redeem
  //       handleSuccessfulRedeem();
  //     }
  //   }

  //   return () => {
  //     init = true;
  //   };
  // }, [
  //   couponCode,
  //   merchantId,
  //   status,
  //   msg,
  //   sc,
  //   isLoading,
  //   handleSuccessfulRedeem,
  // ]);

  useEffect(() => {
    const handleSuccessfulRedeem = async () => {
      try {
        const resCoupon = await CouponService.get(couponCode);

        if (resCoupon && resCoupon.stampCard.id) {
          const resStampCard = await StampCardService.get(
            resCoupon.stampCard.id,
          );

          const resMilestone = await LoyaltyRewardService.listMilestone(
            resStampCard.loyalty_campaign.id,
          );

          if (resMilestone && resMilestone.length > 0) {
            setMilestoneThresholdList(resMilestone.map((m) => m.threshold));
          }

          setStampCard(resStampCard);
          setAddedStamp(1);
          setTimeout(() => {
            setIsLoading(false);
            setStampSuccessDialog(true);
          }, 500);
        }
      } catch (e) {
        console.log('Error fetching coupon after redeem: ', e);
      }
    };

    const handleErrorRedeem = async () => {
      // find if user is a member of the merchant by fetching stampcards using merchantId
      if (
        msg &&
        (msg === 'redeemed_before' || msg === 'redeemed_failed') &&
        merchantId
      ) {
        // check if user is a member of the merchant
        try {
          const resStampCards =
            await StampCardService.listByMerchantId(merchantId);

          if (resStampCards.length === 0) {
            setMId(merchantId);
            selectedMerchant?.setMerchant({ merchantId: merchantId });
            sc?.setStampCard({
              selectedStampCardId: '',
              selectedSlotNumber: 0,
              selectedStampCampaignId: '0',
            });
            // not a member
            setTimeout(() => {
              setIsLoading(false);
              setLaunchAlertDialog(true);
            }, 500);
          } else {
            setMId(merchantId);
            selectedMerchant?.setMerchant({ merchantId: merchantId });
            // is a member
            sc?.setStampCard({
              selectedStampCardId: resStampCards[0].id,
              selectedSlotNumber: resStampCards[0].slotNumber,
              selectedStampCampaignId: resStampCards[0].loyalty_campaign.id,
            });
            setTimeout(() => {
              setIsLoading(false);
              setLaunchAlertDialog(true);
            }, 500);
          }
        } catch (e) {
          setMId(merchantId);
          selectedMerchant?.setMerchant({ merchantId: merchantId });
          sc?.setStampCard({
            selectedStampCardId: '',
            selectedSlotNumber: 0,
            selectedStampCampaignId: '0',
          });
          setTimeout(() => {
            setIsLoading(false);
            setLaunchAlertDialog(true);
          }, 500);
        }
      } else {
        if (msg === 'not_found') {
          // if coupon not found then show invalid dialog
          selectedMerchant?.setMerchant({ merchantId: merchantId });
          sc?.setStampCard({
            selectedStampCardId: '',
            selectedSlotNumber: 0,
            selectedStampCampaignId: '0',
          });
          setTimeout(() => {
            setIsLoading(false);
            setLaunchAlertDialog(true);
          }, 500);
        }
      }
      // try {
      //   const resStampCards = await StampCardService.listByMerchantId(mId);

      //   if (resStampCards.length === 0) {
      //     // not a member
      //     setTimeout(() => {
      //       setIsLoading(false);
      //       setLaunchAlertDialog(true);
      //     }, 500);
      //   } else {
      //     // is a member
      //     sc?.setStampCard({
      //       selectedStampCardId: resStampCards[0].id,
      //       selectedSlotNumber: resStampCards[0].slotNumber,
      //       selectedStampCampaignId: resStampCards[0].loyalty_campaign.id,
      //     });
      //     setTimeout(() => {
      //       setIsLoading(false);
      //       setLaunchAlertDialog(true);
      //     }, 500);
      //   }
      // } catch (e) {
      //   setTimeout(() => {
      //     console.log('Error: ', e);
      //     setIsLoading(false);
      //     setLaunchAlertDialog(true);
      //   }, 500);
      // }
    };
    // const redeem = async () => {
    //   // check if coupon is valid for redeem
    //   try {
    //     const res = await CouponService.get(code);
    //     console.log('Fetch Coupon: ', res);
    //     if (res && !res.redeemed && code.length > 0 && isLoading) {
    //       // valid for redeem
    //       console.log('Coupon is valid for redeem');
    //       try {
    //         const resCoupon = await CouponService.redeem(code);

    //         if (resCoupon && resCoupon.stampCard.id) {
    //           try {
    //             const resStampCard = await StampCardService.get(
    //               resCoupon.stampCard.id,
    //             );

    //             const resMilestone = await LoyaltyRewardService.listMilestone(
    //               resStampCard.loyalty_campaign.id,
    //             );

    //             if (resMilestone && resMilestone.length > 0) {
    //               setMilestoneThresholdList(
    //                 resMilestone.map((m) => m.threshold),
    //               );
    //             }

    //             setStampCard(resStampCard);
    //             setMerchantId(resStampCard.merchant.id);
    //             selectedMerchant?.setMerchant({
    //               merchantId: resStampCard.merchant.id,
    //             });
    //             setTimeout(() => {
    //               setCode('');
    //               setAddedStamp(1);
    //               setIsLoading(false);
    //               setStampSuccessDialog(true);
    //             }, 500);
    //           } catch (e) {
    //             setTimeout(() => {
    //               setCode('');
    //               setIsLoading(false);
    //             }, 500);
    //           }
    //         } else {
    //           setTimeout(() => {
    //             setCode('');
    //             setIsLoading(false);
    //             setLaunchAlertDialog(true);
    //           }, 500);
    //         }
    //       } catch (e) {
    //         // redeem failed and no info of merchant
    //         // try to check if user is a member of the merchant
    //         try {
    //           const resMerchants =
    //             await MerchantService.listMerchantsByMembership();
    //           if (resMerchants && resMerchants.length > 0) {
    //             selectedMerchant?.setMerchant({
    //               merchantId: resMerchants[0].id,
    //             });
    //             setMerchantId(resMerchants[0].id);
    //             const resStampCardList =
    //               await StampCardService.listByMerchantId(resMerchants[0].id);
    //             if (resStampCardList && resStampCardList.length > 0) {
    //               sc?.setStampCard({
    //                 selectedStampCardId: resStampCardList[0].id,
    //                 selectedSlotNumber: resStampCardList[0].slotNumber,
    //                 selectedStampCampaignId:
    //                   resStampCardList[0].loyalty_campaign.id,
    //               });
    //             }
    //           }
    //           setTimeout(() => {
    //             console.log('Error: ', e);
    //             setCode('');
    //             setIsLoading(false);
    //             setLaunchAlertDialog(true);
    //           }, 500);
    //         } catch (e) {
    //           // no memberships
    //           setTimeout(() => {
    //             console.log('Error: ', e);
    //             setCode('');
    //             setIsLoading(false);
    //             setLaunchAlertDialog(true);
    //           }, 500);
    //         }
    //       }
    //     }
    //   } catch (e) {
    //     setTimeout(() => {
    //       setCode('');
    //       console.log('Cannot fetch coupon');
    //       setIsLoading(false);
    //       setLaunchAlertDialog(true);
    //       return;
    //     }, 500);
    //   }
    // };

    // const fetchCoupon = async () => {
    //   const res = await CouponService.get(code);
    //   console.log('Fetch Coupon: ', res);

    //   if (res.redeemed) {
    //     setMerchantId(res.company.id);
    //     selectedMerchant?.setMerchant({ merchantId: res.company.id });
    //     // check if user is a merchant member
    //     try {
    //       const resStampCards = await StampCardService.listByMerchantId(
    //         res.company.id,
    //       );
    //       if (resStampCards.length === 0) {
    //         // not a member
    //         setCode('');
    //         setIsLoading(false);
    //         setLaunchAlertDialog(true);
    //       } else {
    //         // is a member
    //         sc?.setStampCard({
    //           selectedStampCardId: resStampCards[0].id,
    //           selectedSlotNumber: resStampCards[0].slotNumber,
    //           selectedStampCampaignId: resStampCards[0].loyalty_campaign.id,
    //         });
    //         setCode('');
    //         setIsLoading(false);
    //         setLaunchAlertDialog(true);
    //       }
    //     } catch (e) {
    //       setCode('');
    //       console.log('Error: ', e);
    //       setIsLoading(false);
    //       setLaunchAlertDialog(true);
    //     }
    //   } else {
    //     if (isLoading && code.length > 0 && selectedMerchant && sc) {
    //       // redeem();
    //       console.log('Coupon is valid for redeem');
    //       // check if coupon is valid for redeem
    //       try {
    //         const res = await CouponService.get(code);
    //         console.log('Fetch Coupon: ', res);
    //         if (res && !res.redeemed && code.length > 0 && isLoading) {
    //           // valid for redeem
    //           console.log('Coupon is valid for redeem');
    //           try {
    //             const resCoupon = await CouponService.redeem(code);

    //             if (resCoupon && resCoupon.stampCard.id) {
    //               try {
    //                 const resStampCard = await StampCardService.get(
    //                   resCoupon.stampCard.id,
    //                 );

    //                 const resMilestone =
    //                   await LoyaltyRewardService.listMilestone(
    //                     resStampCard.loyalty_campaign.id,
    //                   );

    //                 if (resMilestone && resMilestone.length > 0) {
    //                   setMilestoneThresholdList(
    //                     resMilestone.map((m) => m.threshold),
    //                   );
    //                 }

    //                 setStampCard(resStampCard);
    //                 setMerchantId(resStampCard.merchant.id);
    //                 selectedMerchant?.setMerchant({
    //                   merchantId: resStampCard.merchant.id,
    //                 });
    //                 setTimeout(() => {
    //                   setCode('');
    //                   setAddedStamp(1);
    //                   setIsLoading(false);
    //                   setStampSuccessDialog(true);
    //                 }, 500);
    //               } catch (e) {
    //                 setTimeout(() => {
    //                   setCode('');
    //                   setIsLoading(false);
    //                 }, 500);
    //               }
    //             } else {
    //               setTimeout(() => {
    //                 setCode('');
    //                 setIsLoading(false);
    //                 setLaunchAlertDialog(true);
    //               }, 500);
    //             }
    //           } catch (e) {
    //             // redeem failed and no info of merchant
    //             // try to check if user is a member of the merchant
    //             try {
    //               const resMerchants =
    //                 await MerchantService.listMerchantsByMembership();
    //               if (resMerchants && resMerchants.length > 0) {
    //                 selectedMerchant?.setMerchant({
    //                   merchantId: resMerchants[0].id,
    //                 });
    //                 setMerchantId(resMerchants[0].id);
    //                 const resStampCardList =
    //                   await StampCardService.listByMerchantId(
    //                     resMerchants[0].id,
    //                   );
    //                 if (resStampCardList && resStampCardList.length > 0) {
    //                   sc?.setStampCard({
    //                     selectedStampCardId: resStampCardList[0].id,
    //                     selectedSlotNumber: resStampCardList[0].slotNumber,
    //                     selectedStampCampaignId:
    //                       resStampCardList[0].loyalty_campaign.id,
    //                   });
    //                 }
    //               }
    //               setTimeout(() => {
    //                 console.log('Error: ', e);
    //                 setCode('');
    //                 setIsLoading(false);
    //                 setLaunchAlertDialog(true);
    //               }, 500);
    //             } catch (e) {
    //               // no memberships
    //               setTimeout(() => {
    //                 console.log('Error: ', e);
    //                 setCode('');
    //                 setIsLoading(false);
    //                 setLaunchAlertDialog(true);
    //               }, 500);
    //             }
    //           }
    //         }
    //       } catch (e) {
    //         setTimeout(() => {
    //           setCode('');
    //           console.log('Cannot fetch coupon');
    //           setIsLoading(false);
    //           setLaunchAlertDialog(true);
    //           return;
    //         }, 500);
    //       }
    //     }
    //   }
    // };

    if (isLoading) {
      // fetchCoupon();
      if (status === 'success') {
        // // handle success redemption from deeplink
        handleSuccessfulRedeem();
      } else {
        if (status === 'fail') {
          // check if user is a member of the merchant by fetching stampcards using merchantId
          // find if user is a member of the merchant by fetching stampcards using merchantId
          handleErrorRedeem();
          // setTimeout(() => {
          //   setIsLoading(false);
          //   setLaunchAlertDialog(true);
          // }, 500);
        }
      }
    }

    return () => {
      setIsLoading(false);
    };
  }, [
    code,
    stampCard,
    selectedMerchant,
    sc,
    isLoading,
    couponCode,
    status,
    merchantId,
    msg,
    mId,
  ]);

  if (!merchantId) {
    return null;
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 200,
        }}
      >
        <Spinner />
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 200,
      }}
    >
      <>
        <ErrorDialog
          open={launchAlertDialog}
          onClose={() => {
            setLaunchAlertDialog(false);
            history.replace(merchantId !== '0' ? `/merchant` : '/');
            nav?.setNav({ menuNav: 'home' });
          }}
          onConfirm={() => {
            setLaunchAlertDialog(false);
            history.replace(merchantId !== '0' ? `/merchant` : '/');
            nav?.setNav({ menuNav: 'home' });
          }}
          title="Coupon is invalid"
          body="The coupon is invalid or has already been redeemed."
          confirmButtonText="Dismiss"
        />
        {merchantId && stampCard && (
          <>
            <AddStampDialog
              stampCardId={stampCard.id}
              open={launchAddStampDialog}
              onClose={() => {
                setLaunchAddStampDialog(false);
                selectedMerchant?.setMerchant({ merchantId });
                nav?.setNav({ menuNav: 'home' });
                history.replace(`/merchant`);
                window.location.reload();
              }}
              confirmRedeem={(addedStamp: number) => {
                setAddedStamp(addedStamp);
                setLaunchAddStampDialog(false);
                setStampSuccessDialog(true);
              }}
            />
            <AddStampSuccessDialog
              isComplete={stampCard.quantity === stampCard.redemptionCost}
              isMilestone={
                milestoneThresholdList.length > 0
                  ? milestoneThresholdList.includes(
                      stampCard.quantity + addedStamp,
                    )
                  : false
              }
              open={stampSuccessDialog}
              onClose={() => {
                if (sc) {
                  sc.setStampCard({
                    selectedStampCardId: stampCard.id,
                    selectedSlotNumber: stampCard.slotNumber,
                    selectedStampCampaignId: stampCard.loyalty_campaign.id,
                  });
                }
                setStampSuccessDialog(false);
                selectedMerchant?.setMerchant({ merchantId });
                nav?.setNav({ menuNav: 'home' });
                history.replace(`/merchant`);
              }}
              campaignId={stampCard.loyalty_campaign.id}
              quantity={stampCard.quantity}
              isMultipleStamp={
                addedStamp === 0 ? stampCard.quantity > 1 : addedStamp > 1
              }
              stampAdded={
                addedStamp === 0
                  ? stampCard.quantity.toString()
                  : addedStamp.toString()
              }
              allowAddMoreStamp={false}
              handleAddMoreStamp={() => {
                if (sc) {
                  sc.setStampCard({
                    selectedStampCardId: stampCard.id,
                    selectedSlotNumber: stampCard.slotNumber,
                    selectedStampCampaignId: stampCard.loyalty_campaign.id,
                  });
                }
                setStampSuccessDialog(false);
                selectedMerchant?.setMerchant({ merchantId });
                setLaunchAddStampDialog(true);
              }}
            />
          </>
        )}
      </>
    </div>
  );
}
